package com.eladfinish.bible.contest.screens.main.data

import dev.icerock.moko.resources.StringResource

data class ButtonData(
    val icon: ButtonIcon,
    val stringResource: StringResource,
)
